import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { EntityContext } from "./EntityContext";

export const useEntityProvider = () => {
  const context = useContext(EntityContext);

  if (!context) {
    throw new HookOutOfContextError("useEntityProvider", "EntityContext");
  }

  return context;
};
